import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { EmailLogView, type EmailLogFilters } from '@/features/email-log/EmailLogView'
import { AdminGuard } from '@/components/admin-guard'
import { AdminSubNav } from '@/components/shell/AdminSubNav'

function str(v: unknown): string | undefined {
  return typeof v === 'string' && v ? v : undefined
}

function EmailLog() {
  const search = Route.useSearch()
  const navigate = useNavigate({ from: '/admin/email-log' })
  return (
    <>
      <AdminSubNav />
      <EmailLogView filters={search} onChange={next => navigate({ search: next as never, replace: true })} />
    </>
  )
}

export const Route = createFileRoute('/admin/email-log')({
  // Filters live in the URL, like the queue's, so a view can be shared.
  validateSearch: (raw: Record<string, unknown>): EmailLogFilters => {
    const page = Number(raw.page)
    return {
      direction: str(raw.direction),
      status: str(raw.status),
      q: str(raw.q),
      ticketId: str(raw.ticketId),
      page: Number.isInteger(page) && page > 1 ? page : undefined,
    }
  },
  component: () => (
    <AdminGuard>
      <EmailLog />
    </AdminGuard>
  ),
})
